export default "__VITE_ASSET__D0r46V2W__"